import {
  EnvironmentName,
  EnvironmentSpecificEnv,
} from './environment-specific.type';

export const environmentSpecificEnv: EnvironmentSpecificEnv = {
  environmentName: EnvironmentName.DEV,
  production: false,
  googleAnalytics: {
    id: 'UA-31203397-3',
    tag: 'GTM-K8TC847',
  },
  recaptchaKey: '6Le-VWUqAAAAAPKHxVndckZ4NKNjSmf_YEN-VbNG',
  oktaClientId: '0oa1c3f10yqPqRv6h0h8',
  oktaIssuer:
    'https://alliancewebs.oktapreview.com/oauth2/auslliad098ikdxec0h7',
  splitKey: 'mmvs85g7ikfnplep2tlod8sethdr61uok2q5',
  showOktaSignInButton: true,
  apiSubDomain: 'dev-api',
};
